import React, { Component } from "react"

export default class Input extends Component {
  constructor() {
    super()
    this.state = { inputText: "" }
  }

  render() {
    return (
      <div className="input-group">
        <span className="input-group-addon">
          <i className="material-icons">{this.props.icon}</i>
        </span>
        <div className="form-group label-floating is-empty">
          <label className="control-label">{this.props.label}</label>
          <input
            autoComplete={this.props.autocomplete}
            type={this.props.type}
            className="form-control"
            name={this.props.name}
            onChange={this.props.onChange}
            value={this.props.value}
          />
          <span className="label label-danger" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Input.js